import { lazyLoad } from 'utils/loadable';

export const SurveyPage = lazyLoad(
  () => import('./index'),
  module => module.SurveyPage,
);
